import { ImageUpload } from "components/imageUpload";
import InnerInput from "components/inputs/InnerInput/InnerInput";
import { useTranslation } from "react-i18next";

import styles from "./CmsFooterSocialNetworksCard.module.scss";
import { ReactComponent as DeleteIcon } from "assets/icons/bin-icon.svg";
import cn from "clsx";

type Props = {
  id: number | string;
  alt: string;
  link: string;
  image: string | File;
  onChangeLink: (e: string) => void;
  onChangeAlt: (e: string) => void;
  onAddImage?: (e: File) => void;
  onDeleteBannerCard?: () => void;
  isDeleting?: boolean;
  isActive: boolean;
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  readOnly?: boolean;
};

export const CmsFooterSocialNetworksBannerCard: React.FC<Props> = ({
  id,
  alt,
  link,
  image,
  onChangeLink,
  onChangeAlt,
  onAddImage,
  onDeleteBannerCard,
  isDeleting = false,
  isActive,
  fieldErrors,
  readOnly
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        styles.cmsSocialNetworksCard,
        isDeleting && styles.cmsSocialNetworksCardLoading,
      )}
    >
      <div className={styles.cmsSocialNetworksCardImage}>
        <ImageUpload
          image={image}
          className={styles.cmsSocialNetworksCardImageUpload}
          onAddImage={onAddImage}
          isActive={isActive}
          hasError={Boolean(fieldErrors?.["files"])}
          disabled={readOnly}
        />
      </div>

      <div className={styles.cmsSocialNetworksCardInfo}>
        <div className={styles.cmsSocialNetworksCardAlt}>
          <InnerInput
            value={alt}
            placeholder={t("enterAlt")}
            label={t("alt")}
            type="text"
            id={`socialNetwork-alt-${id}`}
            onChange={onChangeAlt}
            hasError={Boolean(fieldErrors?.["alt"])}
            disabled={readOnly}
          />
        </div>

        <div className={styles.cmsSocialNetworksCardLink}>
          <InnerInput
            value={link}
            placeholder={t("link")}
            label={t("link")}
            type="text"
            id={`socialNetwork-link-${id}`}
            onChange={onChangeLink}
            hasError={Boolean(fieldErrors?.["link"])}
            disabled={readOnly}
          />
        </div>
      </div>

      {!readOnly && (
        <button
          className={styles.cmsSocialNetworksCardDelete}
          onClick={onDeleteBannerCard}
        >
          <DeleteIcon />
        </button>
      )}
    </div>
  );
};
